/*
 * DRIVLY-UI React Components
 * @license MIT
 */
const o=Symbol.for("motionComponentSymbol");export{o as motionComponentSymbol};
//# sourceMappingURL=symbol.js.map
